import React from 'react'

import useStyles from '../styles'
import { MultilineInput } from '_/components/inputs'
import { strMaxLenMessage } from '_/utils/form-validations'
import { useFormContext } from 'react-hook-form'
import { useBudgetForm } from '_/views/budget-view-v2/hooks/use-budget-form'

const NAME = 'serviceDescription'

export function SolutionField() {
  const styles = useStyles()
  const { watch } = useFormContext()
  const { addProblemReadOnly } = useBudgetForm()

  return (
    <MultilineInput
      required
      defaultValue={watch(NAME)}
      placeholder="Descreva aqui o que será feito para resolver o problema"
      name={NAME}
      labelClasses={styles.label}
      label="Solução para o problema"
      rules={{ maxLength: { value: 5000, message: strMaxLenMessage(5000) } }}
      maxRows={100}
      disabled={addProblemReadOnly}
    />
  )
}
